import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSearch } from "@fortawesome/free-solid-svg-icons"

// Data
import siteContent from "../../content/siteContent"

// Styles
import * as styles from "./Navigation.module.scss"

const Navigation = ({ venue, currentLocation, setSearchOpen, searchOpen }) => {
    const isCurrentUrl = (url) => {
        const optionalTrailingSlashUrl = url.replace(/\/$/, "\\/?")
        const pathMatch = new RegExp(`${optionalTrailingSlashUrl}`).test(currentLocation)
        const eventPathMatch = /^\/event\//.test(currentLocation) && /whats-on/.test(url)

        return pathMatch || eventPathMatch
    }

    return (
        <ul className={styles.Navigation}>
            {venue.navigation
                ? venue.navigation.menuItems.nodes.map((page) => {
                      return (
                          <li key={page.id} className={`${isCurrentUrl(page.url) ? styles.isCurrent : ""}`}>
                              <a
                                  href={page.url}
                                  dangerouslySetInnerHTML={{
                                      __html: page.label,
                                  }}
                              ></a>
                          </li>
                      )
                  })
                : siteContent.mainNavigation.map((page) => (
                      <li key={page.id} className={`${isCurrentUrl(page.url) ? styles.isCurrent : ""}`}>
                          <a href={page.url}>{page.title}</a>
                      </li>
                  ))}
            <li className={styles.search}>
                <a href="#">
                    <span>Search</span>
                    <FontAwesomeIcon icon={faSearch} onClick={() => setSearchOpen(!searchOpen)} />
                </a>
            </li>
        </ul>
    )
}

export default Navigation
